module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-rewards-64.2de97cc3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-rewards-64.png
// module id = 3203
// module chunks = 11